import { Helmet } from "react-helmet";
import NewHead from "../../landing/NewHead";
import ServiceFooter from "../../ServiceFooter";
import { Link } from "react-router-dom";

const Blockchainapp = () => {
  return (
    <>
      <NewHead />

      <Helmet>
        <title>Blockchain App Development Company</title>

        <meta name="title" content="Blockchain App Development Company" />
        <meta
          name="description"
          content="Build Future Ready Decentralized Apps with our blockchain app development company."
        />

        {/* <meta
          property="og:title"
          content="Blockchain App Development Company"
        /> */}
        <meta property="og:site_name" content="Beleaf Technologies" />

        <link
          rel="canonical"
          href="https://www.beleaftechnologies.com/blockchain-app-development-company"
        />
      </Helmet>

      <main className="press-release-main press_release_wrap">
        <article className="primary__landing__container">
          <div className="pr_hd_link_wrap">
            <Link to="/pressrelease" className="pr_hd_link_rgt">
              <span className="mr-2">
                <i className="fa-solid fa-arrow-left"></i>{" "}
              </span>
              Go Back
            </Link>
          </div>
        </article>

        {/* hero */}
        <article className="primary__landing__container">
          <div className="pr-re-hero">
            <div className="row pr-rel-row ">
              <div className="col-md-7">
                <h1 className="pr-rel-title ">
                  {" "}
                  Blockchain App Development Company
                </h1>
              </div>
              <div className="col-md-5">
                <img
                  src="https://res.cloudinary.com/dvym3pvnu/image/upload/v1776770473/BlockchainAppDevelopmentCompany_jvhfdt.webp"
                  alt="Blockchain App Development Company"
                  className="pr-rel-img"
                />
              </div>
            </div>
          </div>
        </article>

        <article className="primary__landing__container">
          <div className="pr-rel-content-wrap">
            <p className="pl-rel-content">
              Blockchain technology is changing how businesses operate. Whether
              it’s secure financial transactions, transparent supply chains, or
              digital identity management, blockchain is making everything
              faster, safer, and more reliable. If you're looking to tap into
              this powerful technology, choosing the right blockchain app
              development company is the first and most important step.
            </p>
            <h3 className="pl-rel-subtitle">
              What is a Blockchain App Development Company?
            </h3>
            <p className="pl-rel-content">
              A blockchain app development company is a specialized IT firm that
              designs, develops, and deploys applications using blockchain
              technology. These apps are secure, decentralized, and
              tamper-proof. Unlike traditional apps that run on centralized
              servers, blockchain apps operate on distributed networks like
              Ethereum, Binance Smart Chain, or Polygon.
            </p>
            <p className="pl-rel-content">
              These companies provide full-cycle development services,
              including:
            </p>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">Blockchain consultation</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">UI/UX design</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">Smart contract development</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">dApp development</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">
                  Private and public blockchain integration
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">Blockchain wallet development</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">
                  Crypto payment gateway integration
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">Post-deployment support</p>
              </div>
            </div>
            <p className="pl-rel-content">
              By hiring a top blockchain app development company, you gain
              access to expert developers who understand how to create fast,
              scalable, and secure decentralized solutions designed to your
              preferences.
            </p>
            <h3 className="pl-rel-subtitle">
              Why Choose a Blockchain App Development Company?
            </h3>
            <p className="pl-rel-content">
              Hiring a blockchain app development company gives you a strategic
              edge in the fast-changing digital world. Here's why
            </p>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one">
                  Expertise in Blockchain Technologies
                </h6>
                <p className="pl-rel-content">
                  These companies work with all major blockchain platforms such
                  as Ethereum, Solana, Hyperledger, Avalanche, and Polygon.
                  Their expert developers understand token standards, consensus
                  algorithms, smart contracts, and decentralized storage
                  solutions.
                </p>
              </div>
            </div>{" "}
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one">Custom dApp Solutions</h6>
                <p className="pl-rel-content">
                  A professional blockchain app development company will build a
                  fully customized dApp that fits your unique business model.
                  Whether you want a DeFi platform, NFT marketplace, crypto
                  wallet, or supply chain tracking app—they can build it from
                  scratch.
                </p>
              </div>
            </div>{" "}
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one">
                  Secure and Scalable Development
                </h6>
                <p className="pl-rel-content">
                  Blockchain technology is known for its security. These
                  companies implement the highest levels of encryption, access
                  control, and auditing. They also ensure scalability so your
                  app can handle growth without slowdowns.
                </p>
              </div>
            </div>{" "}
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one"> Faster Time-to-Market</h6>
                <p className="pl-rel-content">
                  With their in-house tools, ready-made frameworks, and agile
                  teams, a blockchain app development company can help launch
                  your project much faster than hiring freelancers or building
                  an in-house team.
                </p>
              </div>
            </div>{" "}
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one">Cost-Effective Services</h6>
                <p className="pl-rel-content">
                  Hiring a dedicated blockchain app development company may seem
                  expensive, but it’s cost-efficient in the long run. You get
                  the expertise, technology, and support all in one package.
                </p>
              </div>
            </div>
            <h3 className="pl-rel-subtitle ">
              Top Use Cases for Blockchain App Development
            </h3>
            <p className="pl-rel-content">
              A reliable blockchain app development company can create solutions
              for a wide range of industries. Some popular use cases include
            </p>
            <h6 className="pl-rel-subtitle-one">
              DeFi (Decentralized Finance)
            </h6>
            <p className="pl-rel-content">
              From lending platforms to yield farming apps, DeFi is changing
              traditional finance. A blockchain app development company can help
              you build secure DeFi platforms with automated smart contracts.
            </p>
            <h6 className="pl-rel-subtitle-one">NFT Marketplaces</h6>
            <p className="pl-rel-content">
              NFTs have exploded in popularity. A trusted blockchain app
              development company can build NFT marketplaces with minting,
              listing, and auction features for creators and collectors.
            </p>
            <h6 className="pl-rel-subtitle-one">Crypto Wallets</h6>
            <p className="pl-rel-content">
              Custom crypto wallets are essential for storing, sending, and
              receiving digital assets. These companies build multi-currency
              wallets with features like QR scanning, seed phrase backup, and
              private key protection.
            </p>
            <h6 className="pl-rel-subtitle-one">Supply Chain Management</h6>
            <p className="pl-rel-content">
              Blockchain brings transparency to supply chains. With the help of
              a blockchain app development company, you can build apps that
              trace products from origin to destination in real-time.
            </p>
            <h6 className="pl-rel-subtitle-one">Healthcare</h6>
            <p className="pl-rel-content">
              Healthcare apps built with blockchain ensure data integrity and
              secure access to patient records. Blockchain can also help track
              pharmaceuticals and fight counterfeit medicine.
            </p>
            <h6 className="pl-rel-subtitle-one">Gaming and Metaverse</h6>
            <p className="pl-rel-content">
              From play-to-earn games to virtual real estate trading, blockchain
              gaming is booming. A skilled blockchain app development company
              can integrate NFTs, tokens, and wallet functionalities into your
              games.
            </p>
            <h3 className="pl-rel-subtitle ">
              Key Features Offered by a Blockchain App Development Company
            </h3>
            <p className="pl-rel-content">
              Here are the core services you can expect when you hire a top
              blockchain app development company
            </p>
            <h6 className="pl-rel-subtitle-one"> Smart Contract Development</h6>
            <p className="pl-rel-content">
              Develop error-free smart contracts for Ethereum, Binance Smart
              Chain, and other networks.
            </p>
            <h6 className="pl-rel-subtitle-one"> Crypto Wallet Integration</h6>
            <p className="pl-rel-content">
              Secure integration of digital wallets with support for multiple
              currencies and networks.
            </p>
            <h6 className="pl-rel-subtitle-one"> Token Creation</h6>
            <p className="pl-rel-content">
              Launch your own cryptocurrency token (ERC-20, BEP-20, or custom
              standard).
            </p>
            <h6 className="pl-rel-subtitle-one"> dApp Development</h6>
            <p className="pl-rel-content">
              Create powerful decentralized apps for finance, gaming,
              healthcare, and more.
            </p>
            <h6 className="pl-rel-subtitle-one">
              {" "}
              Custom Blockchain Development
            </h6>
            <p className="pl-rel-content">
              Build a new blockchain protocol tailored to your business needs.
            </p>
            <h6 className="pl-rel-subtitle-one">Exchange Development</h6>
            <p className="pl-rel-content">
              Launch your own centralized or decentralized crypto exchange with
              complete trading features.
            </p>
            <h6 className="pl-rel-subtitle-one">Security Audits</h6>
            <p className="pl-rel-content">
              Professional audit services to identify and fix vulnerabilities in
              your app or smart contracts.
            </p>
            <h3 className="pl-rel-subtitle ">
              How to find the Best Blockchain App Development Company
            </h3>
            <p className="pl-rel-content">
              With so many companies out there, choosing the best blockchain app
              development company can be tricky.
            </p>
            <h6 className="pl-rel-subtitle-one pl-rel-mb-24px">
              Check Portfolio
            </h6>
            <p className="pl-rel-content">
              Look for past projects, client case studies, and testimonials. A
              good blockchain app development company will proudly display
              successful apps they’ve built.
            </p>
            <h6 className="pl-rel-subtitle-one pl-rel-mb-24px">
              Evaluate Technical Skills
            </h6>
            <p className="pl-rel-content">
              They should have a team skilled in Solidity, Rust, Golang,
              JavaScript, Node.js, and frameworks like Web3.js, Ethers.js, and
              Truffle.
            </p>
            <h6 className="pl-rel-subtitle-one pl-rel-mb-24px">
              Look for End-to-End Services
            </h6>
            <p className="pl-rel-content">
              From ideation to post-launch support, the company should handle
              every aspect of blockchain app development.
            </p>
            <h6 className="pl-rel-subtitle-one pl-rel-mb-24px">
              Consider Industry Experience
            </h6>
            <p className="pl-rel-content">
              Some companies specialize in DeFi, others in gaming, and some in
              healthcare. Choose a blockchain app development company with
              experience in your industry.
            </p>
            <h6 className="pl-rel-subtitle-one pl-rel-mb-24px">
              Communication & Support
            </h6>
            <p className="pl-rel-content">
              Timely updates, dedicated project managers, and 24/7 support are
              signs of a reliable partner.
            </p>
            <h3 className="pl-rel-subtitle ">
              Technologies Used by Blockchain App Development Companies
            </h3>
            <p className="pl-rel-content">
              Here are some of the top technologies a professional blockchain
              app development company uses
            </p>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one"> Blockchain Platforms</h6>
                <p className="pl-rel-content">
                  Ethereum, Solana, Polygon, Avalanche, Binance Smart Chain
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one">
                  Smart Contract Languages
                </h6>
                <p className="pl-rel-content">Solidity, Rust, Vyper, Go</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one">Front-End Technologies </h6>
                <p className="pl-rel-content">React, Vue.js, Angular</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one"> Back-End Technologies</h6>
                <p className="pl-rel-content">Node.js, Python, Java</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one">Databases</h6>
                <p className="pl-rel-content">IPFS, MongoDB, PostgreSQL</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one">Tools & Frameworks</h6>
                <p className="pl-rel-content">
                  Web3.js, Ethers.js, Truffle, Hardhat, Ganache
                </p>
              </div>
            </div>
            <h3 className="pl-rel-subtitle ">
              Benefits of Working with a Blockchain App Development Company
            </h3>
            <p className="pl-rel-content">
              Choosing the right blockchain app development company can bring
              many benefits
            </p>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">
                  Faster development and deployment{" "}
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">
                  Access to skilled developers and blockchain architects
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">
                  Enhanced app security and performance
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">
                  Reduced time and cost of development
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">
                  Post-launch support and maintenance
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">
                  100% customized dApp development
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">
                  Seamless integration with existing business systems
                </p>
              </div>
            </div>
            <h3 className="pl-rel-subtitle ">Future of Blockchain Apps</h3>
            <p className="pl-rel-content">
              The demand for blockchain apps is only going to increase.
              Businesses across all sectors—finance, real estate, logistics,
              retail, gaming—are adopting blockchain for its transparency and
              security. By working with an experienced blockchain app
              development company, you are positioning your business for the
              future.
            </p>
            <p className="pl-rel-content">
              Emerging trends like Layer-2 scaling, zero-knowledge proofs, AI +
              blockchain integration, and tokenized assets will dominate the
              future of blockchain. A forward-thinking blockchain app
              development company can help you stay ahead of the curve by
              adopting these trends early.
            </p>
            <h3 className="pl-rel-subtitle ">
              Cost quoted by Blockchain App Development Company
            </h3>
            <p className="pl-rel-content">
              The cost of blockchain app development varies with many factors
            </p>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">App complexity</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">Number of features</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">Blockchain platform used</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">Smart contract requirements</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">UI/UX design scope</p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <p className="pl-rel-content">Timeframe for delivery</p>
              </div>
            </div>
            <p className="pl-rel-content">
              On average, the price to develop a simple blockchain app may start
              at $10,000 and can go beyond $200,000 for complex DeFi platforms
              or blockchain apps.
            </p>
            <p className="pl-rel-content">
              A transparent blockchain app development company will give you a
              detailed estimate based on your project scope.
            </p>
            <h3 className="pl-rel-subtitle ">
              Why Your Business Needs Blockchain Today
            </h3>
            <p className="pl-rel-content">
              Still wondering if blockchain is right for you? Here are some
              strong reasons to go for it
            </p>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one"> Security</h6>
                <p className="pl-rel-content">
                  Your data is encrypted and immutable.
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one"> Transparency</h6>
                <p className="pl-rel-content">
                  Transactions done are transparent on the blockchain.
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one"> Speed</h6>
                <p className="pl-rel-content">
                  Peer-to-peer transactions remove middlemen and delays.
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one"> Cost-Saving</h6>
                <p className="pl-rel-content">
                  Fewer intermediaries and automated smart contracts reduce
                  operational costs.
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one"> Interoperability</h6>
                <p className="pl-rel-content">
                  Blockchain apps can easily interact with other dApps or
                  protocols.
                </p>
              </div>
            </div>
            <div className="pl-rl-flx">
              <i className="fa-solid fa-angle-right pl-rel-icon"></i>

              <div>
                <h6 className="pl-rel-subtitle-one"> Competitive Advantage</h6>
                <p className="pl-rel-content">
                  Be among the early adopters and lead your industry.
                </p>
              </div>
            </div>
            <h3 className="pl-rel-subtitle">Final Thoughts</h3>
            <p className="pl-rel-content">
              Blockchain is not just a trend—it’s the future of business, data,
              and trust. If you want to unlock the power of decentralization,
              security, and transparency, you need the right technology partner.
              A professional blockchain app development company will guide you
              from idea to launch and beyon. Whether you’re a startup or an
              enterprise, now is the perfect time to invest in blockchain. Build
              your own DeFi app, NFT platform, or crypto exchange with a trusted
              blockchain app development company and shape the future of your
              industry.
            </p>
          </div>
        </article>

        {/* faq */}
        <article className="primary__landing-content-container">
          <div className="landing-faq-wrapper">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="landing-faq-left-title">
                  Frequently Asked <span className="faq-span">Questions.</span>{" "}
                  {""}
                </h6>
              </div>
              <div className="col-lg-6">
                <div>
                  <div className="container">
                    <div className="accordion" id="faq">
                      <div className="landing-faq-card">
                        <div className="landing-faq-header" id="faqhead1">
                          <button
                            className="landing-faq-title collapsed"
                            type="button"
                            data-toggle="collapse"
                            data-target="#faq1"
                            aria-expanded="true"
                            aria-controls="faq1"
                          >
                            What does a blockchain app development company do?
                          </button>
                        </div>

                        <div
                          id="faq1"
                          className="collapse"
                          aria-labelledby="faqhead1"
                          data-parent="#faq"
                        >
                          <div className="landing-faq-content">
                            A blockchain app development company builds
                            decentralized applications using blockchain
                            technology and smart contracts.
                          </div>
                        </div>
                      </div>

                      <div className="landing-faq-card">
                        <div className="landing-faq-header" id="faqhead2">
                          <div
                            className="landing-faq-title collapsed"
                            data-toggle="collapse"
                            data-target="#faq2"
                            aria-expanded="true"
                            aria-controls="faq2"
                          >
                            How much does blockchain app development cost?
                          </div>
                        </div>

                        <div
                          id="faq2"
                          className="collapse"
                          aria-labelledby="faqhead2"
                          data-parent="#faq"
                        >
                          <div className="landing-faq-content">
                            Costs vary depending on the project scope, but
                            typically start around $20,000 for basic apps.
                          </div>
                        </div>
                      </div>

                      <div className="landing-faq-card">
                        <div className="landing-faq-header" id="faqhead3">
                          <div
                            className="landing-faq-title collapsed"
                            data-toggle="collapse"
                            data-target="#faq3"
                            aria-expanded="true"
                            aria-controls="faq3"
                          >
                            Time takes to build a blockchain app?
                          </div>
                        </div>

                        <div
                          id="faq3"
                          className="collapse"
                          aria-labelledby="faqhead3"
                          data-parent="#faq"
                        >
                          <div className="landing-faq-content">
                            Simple dApps take 2–3 months, while complex
                            platforms like DeFi apps can take 6–12 months.
                          </div>
                        </div>
                      </div>

                      <div className="landing-faq-card">
                        <div className="landing-faq-header" id="faqhead4">
                          <div
                            className="landing-faq-title collapsed"
                            data-toggle="collapse"
                            data-target="#faq4"
                            aria-expanded="true"
                            aria-controls="faq4"
                          >
                            Which industries can use blockchain apps?
                          </div>
                        </div>

                        <div
                          id="faq4"
                          className="collapse"
                          aria-labelledby="faqhead4"
                          data-parent="#faq"
                        >
                          <div className="landing-faq-content">
                            Finance, healthcare, supply chain, gaming, real
                            estate, and education are top sectors using
                            blockchain apps.
                          </div>
                        </div>
                      </div>

                      <div className="landing-faq-card">
                        <div className="landing-faq-header" id="faqhead5">
                          <div
                            className="landing-faq-title collapsed"
                            data-toggle="collapse"
                            data-target="#faq5"
                            aria-expanded="true"
                            aria-controls="faq5"
                          >
                            Can I create my own crypto token with a blockchain
                            app development company?
                          </div>
                        </div>

                        <div
                          id="faq5"
                          className="collapse"
                          aria-labelledby="faqhead5"
                          data-parent="#faq"
                        >
                          <div className="landing-faq-content">
                            Yes! These companies offer token development
                            services for ERC-20, BEP-20, and custom standards.
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </article>
      </main>

      <ServiceFooter />
    </>
  );
};

export default Blockchainapp;
